import { z } from 'zod';

const ZAttributeInput = z.object({
  key: z.string(),
  value: z.string(),
});

const ZCommandStatus = z.enum(['PENDING', 'CREATED', 'ERROR', 'CANCELLED', 'UPDATED', 'IDLE']);

export const ZInboundFormMessage = z.object({
  origin: z.string().optional(),
  figpiiData: z.string().optional(),
  emitter: z.string(),
  requestId: z.string(),
  language: z.enum(['fr', 'en', 'es', 'it', 'de']),
  source: z.enum([
    'product',
    'cart',
    'collections',
    'custom',
    'customV2',
    'product-form',
    'custom-prestashop',
  ]),
  analytics_source: z.enum(['product', 'cart', 'side-cart']).optional(),
  domain: z.string().optional(),
  theme: z.string().optional(),
  sessionKey: z.string().optional().default('DEFAULT_KEY'),
  commandStatus: ZCommandStatus,
  shopId: z.string(),
  shopName: z.string().optional(),
  tos: z.string().optional(),
  expiration: z.number().default(0),
  countryCode: z.string().optional(),
  cart: z.object({
    id: z.string().optional(),
    discountCodes: z.string().array().optional(),
    customAttributes: z.array(ZAttributeInput).optional(),
    currencyId: z.string().optional(),
    languageId: z.string().optional(),
    source: z.string().optional(),
    lineItems: z
      .object({
        productId: z.string().optional(),
        quantity: z.number().positive(),
        variantId: z.string().optional(),
        customizationId: z.string().optional(),
        customAttributes: z.array(ZAttributeInput).optional(),
        amount: z.number().optional(),
      })
      .array()
      .optional(),
    note: z.string().optional(),
  }),
  currentUser: z
    .object({
      id: z.string().optional(),
      email: z.string().optional(),
      firstName: z.string().optional(),
      lastName: z.string().optional(),
      phone: z.string().optional(),
      address: z
        .object({
          id: z.string().optional(),
          address1: z.string().optional(),
          address2: z.string().optional(),
          city: z.string().optional(),
          zip: z.string().optional(),
          province: z.string().optional(),
          provinceCode: z.string().optional(),
          countryCode: z.string().optional(),
          country: z.string().optional(),
        })
        .optional(),
    })
    .optional(),
  deliveryCutOffDelta: z.number().optional(),
  deliveryDateEstimated: z.string().optional(),
  deliveryCountryCode: z.string().optional(),
  analytics: z.record(z.string(), z.string()).optional(),
});

export type InboundFormMessage = z.infer<typeof ZInboundFormMessage>;
